/*
 * @Author: fang.lijuan
 * @Date: 2017-12-08
 * @LastEditTime : 2020-01-09 18:29:55
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\networkResource\featuredResource\featuredResourceRouter.js
 * @Description: 特色资源路由
 */

'use strict';
angular.module('featuredResourceRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource.featuredresource.push', {
                // push稿
                url: '/push',
                views: {
                    'main@front.networksource.featuredresource': {
                        templateUrl: './networkResource/networksource_main_tpl.html',
                    },
                },
            })
            .state('front.networksource.featuredresource.robot', {
                // 机器人稿
                url: '/robot',
                views: {
                    'main@front.networksource.featuredresource': {
                        templateUrl: './networkResource/networksource_main_tpl.html',
                    },
                },
            })
            .state('front.networksource.featuredresource.toutiao', {
                // 头条稿
                url: '/toutiao',
                views: {
                    'main@front.networksource.featuredresource': {
                        templateUrl: './networkResource/networksource_main_tpl.html',
                    },
                },
            });
    },
]);
